import React, { useEffect, useRef } from 'react';
import { useChatStore } from '../../store/chatStore';
import MessageBubble from './MessageBubble';
import styles from './MessageList.module.css'; // Import the CSS module

const MessageList: React.FC = () => {
  const messages = useChatStore((state) => state.messages);
  const currentAIMessage = useChatStore((state) => state.currentAIMessage);
  const isLoadingHistory = useChatStore((state) => state.isLoadingHistory);
  const historyError = useChatStore((state) => state.historyError);
  const streamError = useChatStore((state) => state.streamError);

  const messagesEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, currentAIMessage]); // Scroll on new messages or when AI message updates

  const messageListStyle: React.CSSProperties = {
    flexGrow: 1,
    overflowY: 'auto',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  };

  if (isLoadingHistory) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Se încarcă istoricul...</div>;
  }

  // Display history error IF there are no messages and no AI message being streamed
  if (historyError && messages.length === 0 && !currentAIMessage) {
    return <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>Eroare la încărcarea istoricului: {historyError}</div>;
  }

  // Welcome message for empty chat
  if (messages.length === 0 && !currentAIMessage && !isLoadingHistory && !historyError) {
    return (
      <div className={styles.welcomeMessageContainer}>
        <h3 className={styles.welcomeMessageTitle}>Ce provocări de marketing încerci să rezolvi astăzi?</h3>
        <p className={styles.welcomeMessageSubtitle}>Întreabă-mă orice despre marketing și creșterea afacerilor.</p>
      </div>
    );
  }

  return (
    <div style={messageListStyle}>
      {messages.map((msg) => (
        <MessageBubble key={msg.id || msg.created_at} message={msg} />
      ))}
      {currentAIMessage && (
        <MessageBubble key="current-ai-message" message={currentAIMessage} />
      )}
      {/* Display stream error if it occurs, typically below the messages */}
      {streamError && (
        <div style={{ padding: '10px', textAlign: 'center', color: 'red' }}>
          {streamError.includes("Google API key not configured") ? 
            "Serviciul AI nu este configurat corect. Te rugăm să contactezi suportul." :
            streamError.includes("Error:") ? 
              streamError : 
              "Eroare la conectarea cu AI. Te rugăm să încerci mai târziu."}
        </div>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList; 